/*
 * Jira Ticket:
 * Created Date: Mon, 20th Apr 2020, 18:01:49 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import uploadFile from './UPLOAD_FILE';

export const CreateTowerMutation = gql`
  mutation CreateTower(
    $siteId: ID!
    $platformHeight: Int!
    $towerTypeId: ID!
    $notes: String!
    $files: [ID!]
  ) {
    data: createTower(
      siteId: $siteId
      platformHeight: $platformHeight
      towerTypeId: $towerTypeId
      notes: $notes
      files: $files
    ) {
      id
      site {
        id
        name
        project {
          id
          name
          organisation {
            id
            name
          }
        }
      }
      createdAt
      type {
        id
      }
      status
      tag
      platformHeight
      notes
      files {
        id
        url
        filename
      }
    }
  }
`;

export default async ({ client, params }) => {
  try {
    if (params.data.files) {
      const uploadRequest = await uploadFile({
        client,
        files: params.data.files,
      });
      params.data.files = uploadRequest.data.data.files.map(x => x.id);
    } else {
      params.data.files = [];
    }
    return client.mutate({
      mutation: CreateTowerMutation,
      variables: {
        ...params.data,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
